import { mixpanelTrack } from "./mixpanelTrack";

// My Club client-side Mixpanel events. Pure-client interactions (import / sort /
// view / filter / upgrade) live here; data-mutating actions
// (update_recommendations) are fired server-side in peareasy-services instead.
//
// Mirrors events/evolutionsMixpanel.ts: routes through the shared mixpanelTrack
// helper, a SECTION constant, and one track* fn per event. Props (subsection,
// filters, sort value, ...) are read from redux selectors at the call site.

const SECTION = "My Club";

export type MyClubSubsection =
  | "Overview"
  | "My Players"
  | "SBC Fodder Breakdown";

type MyClubContentType = "recommendation" | "player";

// `import_club` is fired by events/clubImportMixpanel from the one launch
// chokepoint now, so every surface reports it identically. It used to live here
// as well, which is how the same click could be counted twice.

// Only fired when the user sorts by profit (per the tracking plan). The caller
// guards on value === "profit".
export const trackSort = (params: {
  subsection: MyClubSubsection;
  value: string;
}) => {
  const value = params.value === "date-added" ? "new" : params.value;
  mixpanelTrack("sort", {
    section: SECTION,
    subsection: params.subsection,
    value,
    action_type: "core",
  });
};

export const trackViewContent = (params: {
  subsection: MyClubSubsection;
  content_type: MyClubContentType;
  new_content?: boolean;
}) => {
  mixpanelTrack("view_content", {
    section: SECTION,
    subsection: params.subsection,
    content_type: params.content_type,
    new_content: params.new_content ?? false,
    action_type: "browse",
  });
};

// Fired when the user closes the filters panel. `filters` is the list of active
// filter keys.
export const trackFilter = (params: {
  subsection: MyClubSubsection;
  filters: string[];
}) =>
  mixpanelTrack("filter", {
    section: SECTION,
    subsection: params.subsection,
    filters: params.filters,
    action_type: "browse",
  });

export const trackUpgrade = (params: {
  subsection: MyClubSubsection;
  context: "cta";
}) =>
  mixpanelTrack("upgrade", {
    section: SECTION,
    subsection: params.subsection,
    context: params.context,
    action_type: "lifecycle",
  });
